// Sends the post-move confirmation email to a customer when their order is
// completed. The actual email is formatted + sent by the sendOrderConfirmation
// Lambda (SES); this just hands it the numbers from the charge calculator.
//
// After deploying the Lambda, replace the endpoint below with its URL.
const ORDER_CONFIRMATION_ENDPOINT =
  'https://clrpa7xufk.execute-api.us-east-2.amazonaws.com/default/sendOrderConfirmation';

export interface OrderConfirmationInput {
  email: string;        // customer email (order.tenantID)
  name: string;         // customer name
  monthlyRent: number;  // $/month
  laborMinutes: number; // move labor time, minutes
  moveInCost: number;   // base + (minutes * perMin)
  base: number;         // moving fee base $
  perMin: number;       // moving fee $/min
}

export async function sendOrderConfirmation(input: OrderConfirmationInput): Promise<void> {
  const res = await fetch(ORDER_CONFIRMATION_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`sendOrderConfirmation failed: ${res.status}`);
}
